import { Model } from "@vuex-orm/core";

export interface emailConfigurationEntity {
  emailConfigurationId: number;
  serviceProviderEmailName: string;
  serviceProviderFromEmailAddress: string;
  emailConfigurationStatus: number;
  isDefault: boolean;
  groupIds: number[];
  clientId: number;
  defaultTechnicianId: number;
  ticketTags: string;
  applyClientGroups: boolean;
  createEmailAlerts: boolean;
}

export class emailConfigurationEntity extends Model {
  static entity = "emailConfigurationEntity";
  static primaryKey = "emailConfigurationId";
  static fields() {
    return {
      emailConfigurationId: this.number(0),
      serviceProviderEmailName: this.string(""),
      serviceProviderFromEmailAddress: this.string(null),
      emailConfigurationStatus: this.number(0),
      isDefault: this.boolean(false),
      groupIds: this.attr(null),
      clientId: this.attr(null),
      defaultTechnicianId: this.attr(null),
      ticketTags: this.attr(null),
      applyClientGroups: this.boolean(true),
      createEmailAlerts: this.boolean(false),
    };
  }

  get emailPrefix() {
    if (this.serviceProviderFromEmailAddress) {
      let email: string = this.serviceProviderFromEmailAddress;
      return email.split("@")[0];
    }
    return "";
  }

  get emailPostFix() {
    if (this.serviceProviderFromEmailAddress) {
      let email: string = this.serviceProviderFromEmailAddress;
      return email.split("@")[1];
    }
    return "";
  }

  get isCustomDomainEmail() {
    let postFix = this.emailPostFix;
    if (postFix != "appmail.gorelo.io") {
      return true;
    }

    return false;
  }

  get forwardingAddress() {
    if (this.isCustomDomainEmail) {
      return `${this.emailPrefix}@gorelo.${this.emailPostFix}`;
    }
    return this.serviceProviderFromEmailAddress;
  }

  get groupList() {
    if (this.groupIds != null && this.groupIds.length > 0) {
      try {
        let groupList = JSON.parse(this.groupIds.toString());
        return groupList;
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  get nameWithEmail() {
    return `${this.serviceProviderEmailName} (${this.serviceProviderFromEmailAddress})`;
  }
}
